import { render, staticRenderFns } from "./InfographicPromotionLayout.vue?vue&type=template&id=07953620&scoped=true&"
import script from "./InfographicPromotionLayout.vue?vue&type=script&lang=js&"
export * from "./InfographicPromotionLayout.vue?vue&type=script&lang=js&"
import style0 from "./InfographicPromotionLayout.vue?vue&type=style&index=0&id=07953620&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07953620",
  null
  
)

export default component.exports